<template>
    <div class="h-screen w-screen block dark:text-main-text-dark bg-gray-50 dark:bg-gray-500 overflow-auto">
        <NuxtPage />
    </div>
</template>
